<template>
    <el-dialog title="选择入库产品" :visible.sync="selectProductInDialog" width="1200px" :before-close="handleClickClose"  append-to-body :close-on-click-modal="false" class="custom-form-dialog custom-inventory-dialog">
        <div class="product_in_select_wrap" v-loading="loading">
            <div class="product_in_select_top">
                <el-input size="small" v-model="keywords" placeholder="请输入产品名称"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                    <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                </el-input>
                <el-select v-model="brand_id" size="small" placeholder="请选择品牌"  clearable filterable @clear="handleClickSearch" @change="handleClickSearch" remote reserve-keyword  :remote-method="getBrandList">
                    <el-option v-for="item in brandList" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </div>
            <div class="product_in_select_bottom">
                <div class="product_select_left category" >
                    <div class="category_top" :class="{'active':categoryId == 0}" @click="handleClickCategory({id:0})" >
                        <p>全部产品</p>
                    </div>
                    <div class="category_bottom" :class="{'noActiveTree':categoryId == 0}">
                        <el-tree ref="cateGoryTreeRef"
                                 :data="categoryList"
                                 :draggable="true"
                                 :expand-on-click-node='false'
                                 :props="{children: 'children',label: 'name'}"
                                 check-on-click-node
                                 check-strictly
                                 default-expand-all
                                 node-key="id">
                            <div  class="custom_tree_node" slot-scope="{ node, data }"  @click="handleClickCategory(data)">
                                <div  class="node_label ellipsis">{{node.label }}</div>
                            </div>
                        </el-tree>
                    </div>
                </div>
                <div class="product_select_right">
                    <div class="product_select_wrap">
                        <div class="product_select_list">
                            <div class="product_select_item" v-for="(item,key) in productListData" :key="key" :class="activeInfo && activeInfo.id == item.id ? 'active' : ''">
                                <div class="cover">
                                    <img :src="item.sku_image ? item.sku_image :'https://download.hecoos.com/enlightv/2024-48/01685fc00b3698f7a1b3d02d936e0e92.jpg' " alt="">
                                </div>
                                <div class="content"  @mouseover="handleHoverChange(key)">
                                    <h5 class="ellipsis_2" v-text="item.name"></h5>
                                    <span class="brand ellipsis" v-text="item.brand_name"></span>
                                    <el-popover  placement="bottom"  popper-class="product_spec_popper" :offset="offset" title="" @show="getCloudProductDetail(item,key)" @hide="productSpecPopperHide" width="922" :visible-arrow="false"	  trigger="click">
                                        <span class="change_spec_btn" slot="reference">选择</span>
                                        <div class="product_spec_wrap" v-loading="itemLoading">
                                            <div class="product_spec">
                                                <div class="field_item">
                                                    <div class="field_name">产品全称：</div>
                                                    <div class="field_value" v-if="item.specs_value">
                                                        <el-input size="small" disabled :value="item.specs_value.find(find => (find.checked && find.checked)) ? item.specs_value.find(find => (find.checked && find.checked)).name : ''" placeholder="产品全称选完自动带出"></el-input>
                                                    </div>
                                                </div>
                                                <div class="field_item" v-for="spec in item.specs">
                                                    <div class="field_name">{{spec.name}}：</div>
                                                    <div class="field_value" >
                                                        <span class="spec_value" :class="list.checked ? 'active' : ''" @click="handleClickSelected(item,spec,list)"  v-for="list in spec.values" v-text="list.value"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="product_spec_save">
                                                <el-button size="small" @click="handleClickClose()">取消</el-button>
                                                <el-button size="small" type="primary" @click="handleClickConfirm(item)">确定</el-button>
                                            </div>

                                        </div>
                                    </el-popover>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="product_select_page">
                        <el-pagination background
                                       size="mini"
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"
                                       :current-page="pagination.pageNum"
                                       :page-sizes="pagination.pageSizes"
                                       :page-size="pagination.pageSize"
                                       :layout="pagination.layout"
                                       :pager-count="5"
                                       :total="pagination.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { cloudCateList,cloudProductList,cloudProductDetail,cloudBrandList } from "@/api/index.js"
import {pagination} from '@/mixins'
export default {
    name: "select_product_in",
    props: {
        selectProductInDialog: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading:false,
            itemLoading:false,
            keywords:'',
            brand_id:'',
            BtnDisabled:false,
            brandList:[],
            categoryList:[],
            categoryId:0,
            productListData:[],
            activeInfo:null,
            offset:0
        }
    },
    mixins: [pagination],
    created() {
        this.getBrandList()
        this.getCloudCateList()
    },
    methods: {
        //获取品牌列表
        getBrandList(keyword){
            let postData = {
                page:1,
                pageSize:10,
                name:keyword
            }
            cloudBrandList(postData).then(res => {
                if(res.code == 200){
                    this.brandList = (res.data && res.data.list) ? res.data.list : []
                }
            })
        },
        // 获取分组
        getCloudCateList(){
            this.loading = true;
            let postData = {}
            cloudCateList(postData).then(res => {
                if(res.code == 200){
                    this.categoryList = res.data
                    this.getTableData()
                }
            })

        },
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },
        // 选择分组
        handleClickCategory(data){
            if(data.id == 0){
                this.$refs.cateGoryTreeRef.setCurrentKey();
            }
            this.categoryId = data.id
            this.handleClickSearch()
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                category_id: this.categoryId,
                name: this.keywords,
                brand_id: this.brand_id
            }
            this.loading = true
            cloudProductList(postData).then(res => {
                if(res.code == 200){
                    let {data,total} = res.data
                    this.productListData = data
                    this.pagination.total = total
                    this.loading = false;
                }
            })
        },
        // 弹窗消失
        productSpecPopperHide(){
            this.activeInfo = null
        },
        handleHoverChange(key){
            key = key + 1
            this.offset = key % 3 === 1 ? 323 : key % 3 === 2  ? 17 : -290
        },
        // 获取详情
        getCloudProductDetail(item,key){

            this.activeInfo = item
            let postData = {
                id:item.id
            }
            this.itemLoading = true
            cloudProductDetail(postData).then(res => {
                if(res.code == 200){
                    let specs_value = []
                    res.data.skus.forEach((item)=>{
                       let json = {
                           name:item.name,
                           sku_id:item.id,
                           sku_key:item.sku_key,
                           sku_ids:item.specs.map(map => { return map.spec_value_id}).join(','),
                       }
                        specs_value.push(json)
                    })
                    this.$set(item,'specs_value',specs_value)
                    this.$set(item,'specs',res.data.specs)
                    this.itemLoading = false
                }
            })
        },
        // 选择
        handleClickSelected(item,spec,list){
            spec.values.forEach(list => {
                this.$set(list,'checked',false)
            })
            this.$set(list,'checked',true)
            let specs_value = []
            item.specs.forEach((specItem)=>{
                if(specItem.values){
                    specItem.values.forEach(valueItem => {
                        if(valueItem.checked){
                            specs_value.push(valueItem.id)
                        }
                    })
                }
            })
            let spec_values = specs_value.join(',')
            if(item.specs_value){
                item.specs_value.forEach(item => {
                    if(item.sku_ids == spec_values){
                        this.$set(item,'checked',true)
                    }else{
                        this.$set(item,'checked',false)
                    }
                })
            }
        },
        handleClickClose() {
            this.$emit("update:selectProductInDialog", false)
        },
        handleClickConfirm(item) {
            let data = item.specs_value.find(find => (find.checked && find.checked))
            if(data){
                data.unit = item.unit
                this.$emit("success", data)
                this.$emit("update:selectProductInDialog", false)
            }else{
                this.$message.error('请选择规格')
            }

        },

    }
}
</script>
<style  lang="scss" scoped>
::v-deep .el-pagination__jump{
    display: none !important;
}
@import "@/styles/inventory_management.scss";
</style>